import { useLocation, useNavigate } from "react-router-dom";
import { Work } from "@models/work";
import { DocumentWorkAdd } from "@models/document-work";
import { editLastBread, getLastAvailableLink } from "../../../utils/breadcrumbs";
import { WORKS_BREADCRUMB, WORKS_PATH, WORKS_STRUCTURE_CRUMBS } from "./works.constants";

export function useWorksNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  function buildBreadcrumb(state: unknown) {
    const base = [
      { name: WORKS_BREADCRUMB.ledger },
      { name: WORKS_BREADCRUMB.list, link: WORKS_PATH },
    ];
    const stateRecord = state as { breadcrumbData?: { name: string; link?: string }[] } | null | undefined;
    return [...(editLastBread(stateRecord?.breadcrumbData, WORKS_PATH, state) ?? base)];
  }

  function rowChosen(row: Work) {
    if (!location.state?.breadcrumbData) {
      return;
    }

    const updatedWorks: DocumentWorkAdd[] = [...location.state.works];
    updatedWorks[location.state.workRowIndex] = {
      ...row,
      work_id: row.id,
      hours: 1,
      discount: 0,
      price: row.price ?? 0,
      net: row.price ?? 0,
      total: row.price ?? 0,
    };

    navigate(getLastAvailableLink(location.state.breadcrumbData), {
      replace: true,
      state: {
        ...location.state,
        works: updatedWorks,
        breadcrumbData: location.state.breadcrumbData.slice(0, -1),
      },
    });
  }

  function navigateToStructure(kind: "search" | "browse") {
    const currentState = { ...location.state };
    const breadcrumbData = buildBreadcrumb(currentState);
    const crumb = kind === "search" ? WORKS_STRUCTURE_CRUMBS.search : WORKS_STRUCTURE_CRUMBS.browse;

    navigate(`${WORKS_PATH}/structure/${kind}`, {
      replace: true,
      state: {
        ...currentState,
        breadcrumbData: [...breadcrumbData, { name: crumb }],
      },
    });
  }

  return {
    rowChosen,
    editSearchStructure: () => navigateToStructure("search"),
    editBrowseStructure: () => navigateToStructure("browse"),
    selectRow: Boolean(location.state?.from ?? location.state?.breadcrumbData),
  };
}
